module.exports = __webpack_public_path__ + "static/media/SRPF47_03.2a876f6c.jpg";